import { tStats, tBaseStats } from './type'
import { tCharacterClass } from '../Character/type'

export const ZERO_STATS: tStats = {
  vigor: 0,
  strength: 0,
  intelligence: 0,
  dexterity: 0,
  charisma: 0,
  agility: 0,
  luck: 0,

  armor: 0,
  resistance: 0,
  evasion: 0,

  maxHealthOffset: 0,
  healthRegeneration: 0,
  damageTakenModifier: 0,
  damageTakenRangeModifiers: {
    melee: 0,
    ranged: 0,
  },
  damageReflection: {
    melee: 0,
    ranged: 0,
  },

  attackDamageOffset: 0,
  attackDamageModifier: 0,
  criticalChance: 0,
  criticalDamageModifier: 0,
  damageModifiers: {
    flying: 0,
    undead: 0,
    beast: 0,
  },

  queueConsolidationModifier: 0,
  queueValueSet: undefined,

  goldModifier: 0,
  maxInspirationOffset: 0,
  consumableHealthGainOffset: 0,
  minHealthOffset: 0,
  visionRange: 0,
}

export const BASE_C_STATS: tStats = {
  ...ZERO_STATS,
  criticalDamageModifier: 1.2,
  damageTakenModifier: 1,
  attackDamageModifier: 1,
  criticalChance: 5,
  queueConsolidationModifier: 1,
  consumableHealthGainOffset: 15,
  visionRange: 1,
}

export const CLASS_STATS: Record<tCharacterClass, tStats> = {
  executioner: {
    ...BASE_C_STATS,
    strength: 74,
    vigor: 74,
    intelligence: 44,
    dexterity: 70,
    charisma: 52,
    agility: 58,
    luck: 50,
    armor: 0,
    resistance: 0,
    evasion: 8,
  },
  mercenary: {
    ...BASE_C_STATS,
    strength: 74,
    vigor: 77,
    intelligence: 41,
    dexterity: 52,
    charisma: 72,
    agility: 56,
    luck: 50,
    armor: 0,
    resistance: 0,
    evasion: 7,
  },
  ranger: {
    ...BASE_C_STATS,
    strength: 52,
    vigor: 66,
    intelligence: 46,
    dexterity: 74,
    charisma: 64,
    agility: 77,
    luck: 50,
    armor: 0,
    resistance: 0,
    evasion: 10,
  },
  reaper: {
    ...BASE_C_STATS,
    strength: 48,
    vigor: 60,
    intelligence: 42,
    dexterity: 72,
    charisma: 72,
    agility: 74,
    luck: 50,
    armor: 0,
    resistance: 0,
    evasion: 11,
  },
  student: {
    ...BASE_C_STATS,
    strength: 45,
    vigor: 60,
    intelligence: 74,
    dexterity: 66,
    charisma: 70,
    agility: 70,
    luck: 50,
    armor: 0,
    resistance: 0,
    evasion: 13,
  },
  patrician: {
    ...BASE_C_STATS,
    strength: 44,
    vigor: 50,
    intelligence: 70,
    dexterity: 68,
    charisma: 74,
    agility: 68,
    luck: 50,
    armor: 0,
    resistance: 0,
    evasion: 11,
  },
  corsair: {
    ...BASE_C_STATS,
    strength: 68,
    vigor: 71,
    intelligence: 48,
    dexterity: 54,
    charisma: 73,
    agility: 58,
    luck: 50,
    armor: 0,
    resistance: 0,
    evasion: 8,
  },
  monk: {
    ...BASE_C_STATS,
    strength: 72,
    vigor: 62,
    intelligence: 72,
    dexterity: 60,
    charisma: 48,
    agility: 60,
    luck: 50,
    evasion: 9,
  },
  drifter: {
    ...BASE_C_STATS,
    strength: 70,
    vigor: 70,
    intelligence: 70,
    dexterity: 70,
    charisma: 70,
    agility: 70,
    luck: 30,
    armor: 0,
    resistance: 0,
    evasion: 13,
  },
  enemy: BASE_C_STATS,
}

export const DAMAGE_BONUS_KEYS: (keyof tStats)[] = [
  'goldModifier',
  'attackDamageOffset',
  'attackDamageModifier',
  'criticalChance',
  'criticalDamageModifier',
  'visionRange',
]
export const DEFENSE_BONUS_KEYS: (keyof tStats)[] = [
  'armor',
  'resistance',
  'evasion',
  'healthRegeneration',
  'damageReflection',
]
export const HEALTH_FOCUS_BONUS_KEYS: (keyof tStats)[] = [
  'maxHealthOffset',
  'maxInspirationOffset',
]
export const STAT_BONUS_KEYS: (keyof tBaseStats)[] = [
  'vigor',
  'strength',
  'intelligence',
  'dexterity',
  'charisma',
  'agility',
  'luck',
]

export const STAT_KEY_LABELS: Record<keyof tStats, string> = {
  strength: ' Strength',
  vigor: ' Vigor',
  intelligence: ' Intelligence',
  dexterity: ' Dexterity',
  charisma: ' Charisma',
  agility: ' Agility',
  luck: ' Luck',
  evasion: ' Evasion',
  criticalChance: '% Crit Chance',
  criticalDamageModifier: '% Crit Damage',

  armor: ' Armor',
  resistance: ' Resistance',

  maxHealthOffset: ' Health',
  healthRegeneration: ' Health Regen',
  damageReflection: ' Damage Reflection',
  damageTakenModifier: '% Recieved Damage',
  damageTakenRangeModifiers: '% Recieved Damage from certain sources',

  damageModifiers: ' Damage to certain Enemeies',

  queueConsolidationModifier: ' Queue Consolidation Modifier',
  queueValueSet: ' Queue Value Set',

  attackDamageOffset: ' Raw Damage',
  attackDamageModifier: '% Attack Damage',

  goldModifier: '% Gold Recieved',
  maxInspirationOffset: ' Max Inspiration',
  minHealthOffset: ' Minumum Health',
  consumableHealthGainOffset: ' HP from Consumables',
  visionRange: ' Vison Range',
}
